import { all, takeEvery, fork, put, select, call } from 'redux-saga/effects'
import actions from './actions'
import {
    loginAPI,
    logout,
    getUserInfo,
    updateUserInfoAPI,
    changePasswordAPI,
} from '../../services/apis/AuthAPIServices'

import { getRoleById } from '../../services/apis/RoleAPIServices'
import appAction from '../app/actions'
import { push } from 'react-router-redux'

// storage
import { setLocalData, getLocalData } from '../../services/StorageServices'
import { notification } from 'antd'

function* saga_Login(action) {
    try {
        const { username, password } = action.payload
        const LoginResponse = yield call(loginAPI, username, password)
        console.log('login respone', LoginResponse)

        if (LoginResponse.error.code === 200) {
            const sessionKey = LoginResponse.data.sessionkey
            const profile = LoginResponse.data.userinfo

            setLocalData('session_key', sessionKey)
            yield put(appAction.changeCurrent(['dashboard']))
            // login success
            yield put(
                actions.action.updateState({
                    session_key: sessionKey,
                    userInfo: profile,
                    isLoggedIn: true,
                    isLoading: false,
                })
            )
            notification.success({
                message: 'Đăng nhập thành công',
                description: 'Xin chào ' + profile.display_name,
            })
        } else {
            // login error
            yield put(
                actions.action.updateState({
                    session_key: null,
                    isLoggedIn: false,
                    userInfo: null,
                    isLoading: false,
                    message: LoginResponse.error.message,
                })
            )
            notification.error({
                message: 'Đăng nhập thất bại',
                description: 'Tên đăng nhập hoặc mật khẩu không chính xác',
            })
        }
    } catch (ex) {
        console.log('Login Error : ', ex.message)
    }
}

function* saga_Logout() {
    try {
        yield logout()
        setLocalData('session_key', null)
        notification.success({
            message: 'Đăng xuất thành công',
            description: 'Tạm biệt',
        })
    } catch (ex) {
        console.log('Logout Error : ', ex.message)
    }
}

function* saga_CheckSessionKey() {
    try {
        let request = yield getUserInfo()
        let userInfo

        if (request.error.code === 200) {
            userInfo = request.data

            if (userInfo.roles[0]) {
                let actions = []
                const getRoleResponse = yield getRoleById(userInfo.roles[0])

                console.log('Get role action response : ', getRoleResponse)

                if (getRoleResponse.error.code === 200) {
                    actions = getRoleResponse.data.action_ids
                }

                userInfo = {
                    ...userInfo,
                    ...{
                        actions,
                    },
                }
            } else
                userInfo = {
                    ...userInfo,
                    ...{
                        actions: [],
                    },
                }

            console.log('User info : ', userInfo)

            yield put(
                actions.action.updateState({
                    isLoggedIn: true,
                    userInfo: userInfo,
                    isLoading: false,
                })
            )
        } else {
            yield put(
                actions.action.updateState({
                    session_key: null,
                    isLoggedIn: false,
                    userInfo: null,
                    isLoading: false,
                })
            )
            setLocalData('session_key', null)
        }
    } catch (ex) {
        console.log('Get user info error : ', ex.message)
    }
}
function* saga_updateUserInfo(action) {
    try {
        const { uid, body } = action.payload
        let request = yield updateUserInfoAPI(uid, body)
        console.log('respoe update', request)
        if (request.error.code === 200) {
            yield put(actions.action.getUserInfo())
            notification.success({
                message: 'Cập nhật thông tin thành công',
                description: '',
            })
        }
    } catch (ex) {
        console.log('Logout Error : ', ex.message)
    }
}
function* saga_changePassword(action) {
    try {
        const { body } = action.payload
        let request = yield changePasswordAPI(body)
        console.log('respoe changepass', request)
        if (request.error.code === 200) {
            yield notification.success({
                message: 'Đổi mật khẩu thành công',
                description: 'Vui lòng đăng nhập lại',
            })
            setTimeout(() => {
                window.location.reload()
            }, 2500)
        } else if (request.error.code === 306) {
            notification.success({
                message: 'Mật khẩu cũ không đúng',
                description: 'Vui lòng nhập lại',
            })
        }
    } catch (ex) {
        console.log('changepass Error : ', ex.message)
    }
}
function* listen() {
    yield takeEvery(actions.type.LOGIN, saga_Login)
    yield takeEvery(actions.type.CHECK_SESSION, saga_CheckSessionKey)
    yield takeEvery(actions.type.GET_USER_INFO, saga_CheckSessionKey)
    yield takeEvery(actions.type.LOGOUT, saga_Logout)
    yield takeEvery(actions.type.UPDATE_USERINFO, saga_updateUserInfo)
    yield takeEvery(actions.type.CHANGE_PASSWORD, saga_changePassword)
}

export default function* authSaga() {
    yield all([fork(listen)])
}
